<script setup lang="ts">
import type {BenefitItem} from '~/types/legacy'
import type {Populated} from '~/types/populated'

const props = defineProps<{
  benefit: Populated<BenefitItem>
}>()
</script>

<template>
  <div
    class="group cursor-pointer rounded-lg border border-gray-200 bg-white p-4 shadow-lg transition-all duration-300 ease-in-out hover:bg-main-50 hover:shadow-[0_0_0_2px_#2AAEA3]"
  >
    <div class="mb-4 flex items-center">
      <div class="flex items-center justify-center rounded-full bg-main-50 p-2">
        <div
          class="flex h-12 w-12 items-center justify-center rounded-full border bg-main-100 text-main-700 transition-all duration-300 ease-in-out group-hover:bg-main-500 group-hover:text-white"
        >
          <Icon class="h-6 w-6" :name="props.benefit.icon!" />
        </div>
      </div>
    </div>
    <Heading size="small" class="mb-4">
      {{ props.benefit.title }}
    </Heading>
    <p class="pb-6 text-sm text-gray-600">
      <RichText :raw="props.benefit.description || ''" />
    </p>
  </div>
</template>
